import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const PeoplePlatformRoutes = [
    {
        "url": "/core-hr",
        "name": "appLayout.harriSH.core-hr",
        "type": "frontend",
        "loginRequired": true,
        "abstract": true,
        "platformPage": true,
        "component": "peoplePlatformMain",
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/people-platform/people-platform.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/communication-hub/communication-hub.shared.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/work-limit/work-limit.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/working-patterns/working-patterns.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/pms/pms-shared.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/core-hr-profile-integrations/core-hr-profile-integrations.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/people-list?view&hireDateFrom&hireDateTo&leaveDateFrom&leaveDateTo&employeeStatus&brandType&brandName&parents",
        "name": "appLayout.harriSH.core-hr.list",
        "type": "frontend",
        "platformPage": true,
        "loginRequired": true,
        "views": {
            "people-platform-body": {
                component: "peopleListContainer",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CoreHR"
            }
        ],
        "params": {
            view: {
                dynamic: false
            },
            hireDateFrom: {
                dynamic: true,
            },
            hireDateTo: {
                dynamic: true,
            },
            leaveDateFrom: {
                dynamic: true,
            },
            leaveDateTo: {
                dynamic: true,
            },
            employeeStatus: {
                dynamic: true,
            },
            brandName: {
                dynamic: true,
            },
            brandType: {
                dynamic: true,
            },
            parents: {
                dynamic: true,
            },
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["people_platform", "availability_requests_shared", "core-hr-profile-integrations"]
        },
        "onEnter": ['brandServices', 'hUser', '$state', async (brandServices, hUser, $state) => {
                brandServices.checkAll(hUser.getEntryMode()['brand_id'], [brandServices.SERVICES.TEAM_SCHEDULING, brandServices.SERVICES.CORE_HR], true)
                    .then((services) => {
                    if (!(services[brandServices.SERVICES.TEAM_SCHEDULING] || services[brandServices.SERVICES.CORE_HR])) {
                        if (hUser.isTopLevelContext()) {
                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                        }
                        else {
                            $state.go("appLayout.harriSH.dashboard");
                        }
                    }
                });
            }],
    },
    {
        "url": "/profile-details?user_id&tab&brand_id&shift_start_time&shift_end_time&location_id&engagement_tab&from_date&to_date",
        "name": "appLayout.harriSH.core-hr.profile",
        "type": "frontend",
        "platformPage": true,
        "loginRequired": true,
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CoreHR"
            }
        ],
        "views": {
            "people-platform-body": {
                component: "peopleProfileDetailsContainer",
            }
        },
        "params": {
            tab: {
                dynamic: true,
            },
            shift_start_time: {
                dynamic: true
            },
            shift_end_time: {
                dynamic: true
            },
            location_id: {
                dynamic: true
            },
            engagement_tab: {
                dynamic: true
            },
            from_date: {
                dynamic: true
            },
            to_date: {
                dynamic: true
            }
        },
        "route_dependencies": [
            { type: "library", path: "../ext_libs/jwplayer/jwplayer.js" },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/work-visas-management/work-visas-management.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["people_platform", "employee-card", "employee_termination", "pms-shared", "communication_hub_shared", "on_boarding_journey", "work-visas-management", "core-hr-profile-integrations"]
        },
        "onEnter": ['brandServices', 'hUser', '$state', async (brandServices, hUser, $state) => {
                brandServices.checkAll(hUser.getEntryMode()['brand_id'], [brandServices.SERVICES.TEAM_SCHEDULING, brandServices.SERVICES.CORE_HR], true)
                    .then((services) => {
                    if (!(services[brandServices.SERVICES.TEAM_SCHEDULING] || services[brandServices.SERVICES.CORE_HR])) {
                        if (hUser.isTopLevelContext()) {
                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                        }
                        else {
                            $state.go("appLayout.harriSH.dashboard");
                        }
                    }
                });
            }],
    },
    {
        "url": `/job-approvals/${hmapPathParamRegex}?brandId&jobId&flowId`,
        "name": "appLayout.harriSH.access-portal.job-approvals",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig,
            brandId: {
                dynamic: true,
            },
            jobId: {
                dynamic: true,
            },
            flowId: {
                dynamic: true,
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job_approval"]
        },
        "component": "hmapJobApprovalsListingContainer",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/people-platform/people-platform.downgrade.module");
                }
            }
        ]
    }
];
export const PeoplePlatformTLRoutes = [
    {
        "url": "/tl-core-hr",
        "name": "appLayout.schedule.core-hr",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "abstract": true,
        "views": {
            "body": {
                component: "peoplePlatformMain",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/people-platform/people-platform.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/pms/pms-shared.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/work-limit/work-limit.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/working-patterns/working-patterns.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/core-hr-profile-integrations/core-hr-profile-integrations.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/tl-people-list?view&source&scheduleVisibility&hireDateFrom&hireDateTo&leaveDateFrom&leaveDateTo&employeeStatus",
        "name": "appLayout.schedule.core-hr.list",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "people-platform-body": {
                component: "peopleListContainer",
            }
        },
        "params": {
            view: {
                dynamic: true,
            },
            source: {
                dynamic: true,
            },
            scheduleVisibility: {
                dynamic: true,
            },
            hireDateFrom: {
                dynamic: true,
            },
            hireDateTo: {
                dynamic: true,
            },
            leaveDateFrom: {
                dynamic: true,
            },
            leaveDateTo: {
                dynamic: true,
            },
            employeeStatus: {
                dynamic: true,
            },
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["people_platform", "availability_requests_shared", "core-hr-profile-integrations"]
        },
        "onEnter": ['brandServices', 'hUser', '$state', async (brandServices, hUser, $state) => {
                brandServices.checkAll(hUser.getEntryMode()['brand_id'], [brandServices.SERVICES.TEAM_SCHEDULING], true)
                    .then((services) => {
                    if (!services[brandServices.SERVICES.TEAM_SCHEDULING]) {
                        if (hUser.isTopLevelContext()) {
                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                        }
                        else {
                            $state.go("appLayout.harriSH.dashboard");
                        }
                    }
                });
            }],
    },
    {
        "url": "/tl-profile-details?user_id&tab&brand_id&shift_start_time&shift_end_time&location_id&source",
        "name": "appLayout.schedule.core-hr.profile",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "people-platform-body": {
                component: "peopleProfileDetailsContainer",
            }
        },
        "params": {
            tab: {
                dynamic: true,
            },
            shift_start_time: {
                dynamic: true
            },
            shift_end_time: {
                dynamic: true
            },
            location_id: {
                dynamic: true
            },
            source: {
                dynamic: true,
            },
            user_id: {
                dynamic: true,
            },
            brand_id: {
                dynamic: true,
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["people_platform", "employee-card", "pms-shared", "on_boarding_journey", "work-visas-management", "core-hr-profile-integrations"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/work-visas-management/work-visas-management.downgrade.module");
                }
            }
        ],
        "onEnter": ['brandServices', 'hUser', '$state', async (brandServices, hUser, $state) => {
                brandServices.checkAll(hUser.getEntryMode()['brand_id'], [brandServices.SERVICES.TEAM_SCHEDULING], true)
                    .then((services) => {
                    if (!services[brandServices.SERVICES.TEAM_SCHEDULING]) {
                        if (hUser.isTopLevelContext()) {
                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                        }
                        else {
                            $state.go("appLayout.harriSH.dashboard");
                        }
                    }
                });
            }],
    }
];
//# sourceMappingURL=people-platform.routes.js.map